import { inject, Injectable } from '@angular/core';
import { IUser, UUID } from '@okcargo-apps/shared-domain';
import { UserCommandService } from '@okcargo-apps/shared-infrastructure';

@Injectable({
  providedIn: 'root',
})
export class UsersMutationsService {
  private readonly userCommandService = inject(UserCommandService);

  public createUser(user: IUser): Promise<void> {
    return this.userCommandService.createUser(user);
  }

  public updateUser(user: IUser): Promise<void> {
    return this.userCommandService.updateUser(user);
  }

  public softDeleteUser(id: UUID): Promise<void> {
    return this.userCommandService.softDeleteUser(id);
  }
}
